import HourglassTopTwoToneIcon from "@mui/icons-material/HourglassTopTwoTone";
import MicIcon from "@mui/icons-material/Mic";
import { Button } from "@mui/material";
import { useMemo, useState } from "react";

import SendIcon from "@/components/Icons/Send";
import Locator from "@/locator";

export default function RecordingButton({
  processing,
  progress,
  disabled,
  uploading,
  toggleRecord,
}: {
  processing: boolean;
  progress: number;
  disabled: boolean;
  uploading: boolean;
  toggleRecord: () => void;
}) {
  const recording = progress > 0;
  const [localDisabled, setLocalDisabled] = useState<boolean>(false);

  const buttonIcon = useMemo(() => {
    if (processing || uploading) {
      return <HourglassTopTwoToneIcon sx={{ fontSize: 22 }} />;
    }
    if (recording) {
      return <SendIcon width={22} height={22} />;
    }
    return <MicIcon sx={{ fontSize: 22 }} />;
  }, [recording, processing, uploading]);

  const toggleRecordingLocally = () => {
    setLocalDisabled(() => true);
    toggleRecord();
    setTimeout(() => {
      setLocalDisabled(() => false);
    }, 250);
  };

  return (
    <Button
      id="recordButton"
      disabled={disabled || uploading || localDisabled}
      onClick={() => toggleRecordingLocally()}
      aria-label={Locator.feed.input.recorder.main}
      sx={{
        bgcolor: "#ea580c",
        "&:hover": { bgcolor: "#dc2626" },
        "&:active": { boxShadow: "0 0 0 1px #ea580c" },
        "&:disabled": { bgcolor: "#c2410c", color: "#fdba74" },
        borderRadius: "50%",
        minWidth: 0,
        width: 38,
        height: 38,
        p: 0,
      }}
    >
      {buttonIcon}
    </Button>
  );
}
